/**
 * Client for the workflow service.
 *
 * Types are generated from the service's OpenAPI spec; the calls go through the existing
 * apisauce client rather than a generated one, so they keep the Authorization header and the
 * central 401/403 logout.
 */

import {ApiResponse} from "apisauce";

import {http} from "./api";
import type {paths} from "./api/generated/workflows";

/**
 * The client's baseURL already ends in `/api` and the generated paths are server-absolute.
 * Typed against `keyof paths` so a renamed endpoint fails the build rather than 404ing in
 * production, which is what DEV-5973 was.
 */
const API_PREFIX = "/api";

const relativePath = <Path extends keyof paths & string>(path: Path) =>
  path.slice(API_PREFIX.length);

type SearchOperation = paths["/api/v4/workflows/search"]["post"];

export type SearchRequest = SearchOperation["requestBody"]["content"]["application/json"];
export type SearchResponse = SearchOperation["responses"][200]["content"]["application/json"];

export type WorkflowCard = SearchResponse["cards"][number];
export type WorkflowStatus = WorkflowCard["status"];

export const WorkflowsService = {
  /** One page of workflows. An absent `statuses` means every status, not none. */
  search: (request: SearchRequest): Promise<ApiResponse<SearchResponse>> =>
    http.post<SearchResponse>(relativePath("/api/v4/workflows/search"), request),
};
